import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import queryString from 'query-string';
import { Button } from "antd";
import { LoginOutlined } from "@ant-design/icons";
import './index.scss';
interface ErrorParams {
  info?: string;
  target?: string;
}

const Error: React.FC = () => {
  const params: ErrorParams = queryString.parse(window.location.search.split('?')[1] || '');
  const navigate = useNavigate();

  const goBack = useCallback(() => {
    navigate(`/login?target=${encodeURIComponent(params.target || '')}`);
  }, [params]);

    return (
      <div className="sso-error-body">
        <img src="//static.shihuocdn.cn/admin/files/20241120/e6b974fed4336964bf10256f8e095c55.png" />
        <h1>{params.info || '页面未找到'}</h1>
        {params?.target && <Button type="primary" icon={<LoginOutlined />} onClick={goBack}>返回登录页面</Button>}
      </div>
    );
  };

export default Error;